module.exports = __webpack_public_path__ + "img/50.aad155cf.jpg";